import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { BRAND } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="page-admin-login" className="min-h-[80vh] flex items-center justify-center container-narrow">
      <div className="card-luxe max-w-md w-full text-center">
        <img src={BRAND.logoChurch} alt="logo" className="h-20 w-20 rounded-full mx-auto ring-2 ring-[#D4AF37]/40"/>
        <h1 className="font-serif text-3xl mt-5">Admin Access</h1>
        <p className="text-white/90 mt-3 text-sm leading-relaxed">
          Only authorized leaders can sign in. You'll be redirected to Google for secure login.
        </p>
        <button data-testid="google-login-btn" onClick={startLogin} className="btn-gold w-full mt-6">
          <Crown className="w-4 h-4"/> Continue with Google
        </button>
        <div className="mt-5 text-xs text-white/80 flex items-center justify-center gap-2">
          <Lock className="w-3 h-3"/> Secured by Emergent Auth
        </div>
        {user && !user.is_admin && (
          <div className="mt-4 p-3 rounded-lg bg-[#D91668]/10 border border-[#D91668]/30 text-[#F02078] text-xs">
            Signed in as {user.email} — but this account is not authorized as admin.
          </div>
        )}
      </div>
    </div>
  );
}
